import { toast } from "@/hooks/use-toast";
import { getJobId } from "@/lib/utils";
import { apiServices } from "@/services/api.services";
import { jobId, runDocument } from "@/services/global.services";
import { useEffect, useState } from "react";

type ReprocessDocumentState = {
  workflow_id: string | undefined;
  doc_id: string | undefined;
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export const useReprocessDocument = ({
  company_id,
  user_id,
  loadingList,
  currentCompanyData,
  doc_id,
  setGlobalLoading,
}: any) => {
  const [process, setProcess] = useState(false);
  // const getJobId = async (prop: string, isInProgressExist?: boolean) => {
  //   while (true) {
  //     const { data, error, message } = await apiServices<any>(
  //       jobId.get + prop,
  //       "get"
  //     );

  //     if (data?.process_status !== "in-progress" || isInProgressExist) {
  //       if (data?.error) {
  //         toast({
  //           title: "Error",
  //           variant: "destructive",
  //           description: error.status?.message || message,
  //         });
  //       }

  //       if (data?.status?.error_details?.fail_message) {
  //         toast({
  //           title: "Error",
  //           variant: "destructive",
  //           description: data.status.error_details.fail_message,
  //         });
  //         return { data: null, error: data.status.error_details.fail_message };
  //       }

  //       return { data, error };
  //     }

  //     await new Promise((resolve) => setTimeout(resolve, 5000)); // Wait for 5 seconds before next call
  //   }
  // };

  const reProcessCurrentDocument = async (data: any): Promise<any> => {
    setProcess(true);
    setGlobalLoading(true);
    const runDocumentResponse = await onDocumentReprocess(data);

    if (runDocumentResponse.data.job_id) {
      const jobIdReprocess = await getJobId(runDocumentResponse.data.job_id);
      if (jobIdReprocess?.data) {
        await loadingList({});
      }
    }
    setGlobalLoading(false);
    setProcess(false);
  };

  const onDocumentReprocess = async (prop: any): Promise<any> => {
    const payload = {
      data: prop,
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message } = await apiServices<any>(
      runDocument.post,
      "post",
      payload
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }

    return { data, error };
  };

  const [reprocessDocumentState, setReprocessDocumentState] =
    useState<ReprocessDocumentState>({
      workflow_id: undefined,
      doc_id: undefined,
    });

  useEffect(() => {
    setReprocessDocumentState((prev) => ({
      ...prev,
      workflow_id: currentCompanyData?.settings?.default_workflow,
    }));
  }, [currentCompanyData]);

  useEffect(() => {
    setReprocessDocumentState((prev) => ({
      ...prev,
      doc_id: doc_id,
    }));
  }, [doc_id]);
  return {
    reProcessCurrentDocument,
    process,
    reprocessDocumentState,
    setReprocessDocumentState,
  };
};
